import { render, staticRenderFns } from "./BuddyListMain.vue?vue&type=template&id=7a823f98&"
import script from "./BuddyListMain.vue?vue&type=script&lang=js&"
export * from "./BuddyListMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports